// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalGraph_root__283Ev","empty":"ModalGraph_empty__2efk8"};